import React, {useState} from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedStrategyPlot } from '../pages/slices/simulationStratgySlicer';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

// Custom Tooltip Component
const CustomTooltip = ({ active, payload }) => {

  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div style={{ textShadow:'-1px -1px 0 #131722, 1px -1px 0 #131722, -1px 1px 0 #131722, 1px 1px 0 #131722'}} className="custom-tooltip">
        <p>{`EMA: ${data.ema_1}, ${data.ema_2}`}</p>
      </div>
    );
  }

  return null;
};

const ChartBar = ({ data }) => { 
  
  const [hoveredBar, setHoveredBar] = useState(null);
  const dispatch = useDispatch();  
  const handleClick = (entry) => {

    const dict_sel = {
      'ema_1' : entry.ema_1,
      'ema_2' : entry.ema_2,
      'strategy' : entry.strategy
    };

    dispatch(setSelectedStrategyPlot(dict_sel));    
  };  

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={data}        
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis
          dataKey="strategy"          
          label={{
            value: 'Strategy',
            position: 'insideBottom',
            offset: -3,
            style: { textAnchor: 'middle' }
          }}
        />
        <YAxis
          label={{
            value: 'Percentage Gain',
            angle: -90,
            position: 'insideLeft',
            style: { textAnchor: 'middle' },
            offset: 15
          }}
        />
        <Tooltip cursor={{fill: 'transparent'}} content={<CustomTooltip />} />
        <Bar
          dataKey="final_percentage"
          onMouseEnter={(data, index) => setHoveredBar(index)}
          onMouseLeave={() => setHoveredBar(null)}
          label={{
            position: 'top',
            content: ({ x, y, width, height, value }) => (
              <text
                x={x + width / 2}
                y={y - 5}
                textAnchor="middle"
                fill={value >= 0 ? '#3abf3a' : '#c7c700'}
                fontSize={11}
                fontWeight="bold"
              >
                {value.toFixed(2)}
              </text>
            )
          }}
        >
          {
            data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.best_result ? '#ffd702' : (entry.final_percentage < 0 ? '#ff4646' : '#6bff6b')}
                onClick={() => handleClick(entry)}
                cursor="pointer" // Changes cursor on hover
                fillOpacity={hoveredBar === index ? 1 : 0.8}                
              />
            ))
          }
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default ChartBar;